module.exports = __webpack_public_path__ + "img/alex_assessment_grey.b0bebce3.svg";